
// actions
// functions that causes side effects and can involve asynchronous operations.
// TODO - delete if no actions are required
const actions = {
}

// // // //

export default actions



// WEBPACK FOOTER //
// ./src/store/notification/actions.js